export const INITIAL_WAREHOUSES = [
  {
    id: "WH-001",
    name: "Kattedan Industrial Mega Hub (WH-001)",
    code: "WH-1",
    type: "Central Mother Warehouse",
    address: "Survey No. 42, Kattedan Industrial Area, Near Pillar No. 294, Hyderabad 500077",
    city: "Hyderabad",
    state: "Telangana",
    sqftArea: 35000,
    manager: "Venkateshwar Reddy",
    contactPhone: "+91 98490 11220",
    sections: [
      {
        id: "SEC-A",
        name: "Section A - Bulk Grains & Sona Masoori Rice Pallets",
        code: "SEC-A",
        racks: [
          {
            id: "RCK-A1",
            name: "Rack A1 - Heavy Duty Palletizer",
            code: "RCK-A1",
            shelves: [
              {
                id: "SHF-A1-S1",
                name: "Shelf 1 (Ground Heavy)",
                bins: [
                  { id: "BIN-WH1-A1-101", code: "A1-S1-B1", maxCapacity: 120, currentCount: 94 },
                  { id: "BIN-WH1-A1-102", code: "A1-S1-B2", maxCapacity: 120, currentCount: 110 }
                ]
              },
              {
                id: "SHF-A1-S2",
                name: "Shelf 2 (Mid Stack)",
                bins: [
                  { id: "BIN-WH1-A1-201", code: "A1-S2-B1", maxCapacity: 80, currentCount: 65 },
                  { id: "BIN-WH1-A1-202", code: "A1-S2-B2", maxCapacity: 80, currentCount: 0 }
                ]
              }
            ]
          },
          {
            id: "RCK-A2",
            name: "Rack A2 - Basmati & Premium Grains",
            code: "RCK-A2",
            shelves: [
              {
                id: "SHF-A2-S1",
                name: "Shelf 1 (Pallet Base)",
                bins: [
                  { id: "BIN-WH1-A2-101", code: "A2-S1-B1", maxCapacity: 100, currentCount: 88 },
                  { id: "BIN-WH1-A2-102", code: "A2-S1-B2", maxCapacity: 100, currentCount: 45 }
                ]
              }
            ]
          }
        ]
      },
      {
        id: "SEC-B",
        name: "Section B - Edible Oils, Freedom & Fortune Tins",
        code: "SEC-B",
        racks: [
          {
            id: "RCK-B1",
            name: "Rack B1 - Liquid Storage Spill-Proof",
            code: "RCK-B1",
            shelves: [
              {
                id: "SHF-B1-S1",
                name: "Shelf 1 (15L Tins)",
                bins: [
                  { id: "BIN-WH1-B1-101", code: "B1-S1-B1", maxCapacity: 60, currentCount: 52 },
                  { id: "BIN-WH1-B1-102", code: "B1-S1-B2", maxCapacity: 60, currentCount: 58 }
                ]
              }
            ]
          }
        ]
      },
      {
        id: "SEC-C",
        name: "Section C - Spices, Mirchi & Fast Moving Consumer Goods",
        code: "SEC-C",
        racks: [
          {
            id: "RCK-C1",
            name: "Rack C1 - FMCG Carton Racks",
            code: "RCK-C1",
            shelves: [
              {
                id: "SHF-C1-S1",
                name: "Shelf 1 (Cartons & Pouches)",
                bins: [
                  { id: "BIN-WH1-C1-101", code: "C1-S1-B1", maxCapacity: 150, currentCount: 130 },
                  { id: "BIN-WH1-C1-102", code: "C1-S1-B2", maxCapacity: 150, currentCount: 95 }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "WH-002",
    name: "Begum Bazar Central Distribution Depot (WH-002)",
    code: "WH-2",
    type: "Wholesale Distribution Mandi Depot",
    address: "Shop No. 14-2-88, Mir Alam Mandi Road, Begum Bazar, Hyderabad 500012",
    city: "Hyderabad",
    state: "Telangana",
    sqftArea: 14500,
    manager: "Srinivas Rao",
    contactPhone: "+91 98490 33440",
    sections: [
      {
        id: "SEC-A",
        name: "Section A - Wholesale Staging & B2B Orders",
        code: "SEC-A",
        racks: [
          {
            id: "RCK-A1",
            name: "Rack A1 - Dispatch Bay Racks",
            code: "RCK-A1",
            shelves: [
              {
                id: "SHF-A1-S1",
                name: "Shelf 1",
                bins: [
                  { id: "BIN-WH2-A1-101", code: "K-A1-B1", maxCapacity: 100, currentCount: 75 },
                  { id: "BIN-WH2-A1-102", code: "K-A1-B2", maxCapacity: 100, currentCount: 40 }
                ]
              }
            ]
          }
        ]
      },
      {
        id: "SEC-B",
        name: "Section B - Fast Moving Dals & Ghee",
        code: "SEC-B",
        racks: [
          {
            id: "RCK-B1",
            name: "Rack B1 - High Velocity Pulls",
            code: "RCK-B1",
            shelves: [
              {
                id: "SHF-B1-S1",
                name: "Shelf 1",
                bins: [
                  { id: "BIN-WH2-B1-101", code: "K-B1-B1", maxCapacity: 80, currentCount: 72 }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "WH-003",
    name: "Kukatpally Express Retail Godown (WH-003)",
    code: "WH-3",
    type: "Retail Front Attached Godown",
    address: "Plot 89, Phase 2, Near Forum Sujana Mall, KPHB Colony, Hyderabad 500072",
    city: "Hyderabad",
    state: "Telangana",
    sqftArea: 6500,
    manager: "Anand Deshmukh",
    contactPhone: "+91 98490 55660",
    sections: [
      {
        id: "SEC-A",
        name: "Section A - Store Replenishment & Backroom",
        code: "SEC-A",
        racks: [
          {
            id: "RCK-A1",
            name: "Rack A1 - Daily Counter Fill",
            code: "RCK-A1",
            shelves: [
              {
                id: "SHF-A1-S1",
                name: "Shelf 1",
                bins: [
                  { id: "BIN-WH3-A1-101", code: "D-A1-B1", maxCapacity: 50, currentCount: 42 },
                  { id: "BIN-WH3-A1-102", code: "D-A1-B2", maxCapacity: 50, currentCount: 35 }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];

export const initialWarehouses = INITIAL_WAREHOUSES;

